import * as types from '@/store/mutation-types';
import { mapGetters } from 'vuex';
import {formatDate} from 'element-ui/src/utils/date-util';
import { mobileOk, isWeixin, isMobile } from './utils';
import { doGet, doPost } from '@/axios/http';
export default {
  data () {
    return {
      ww: 0,
      hh: 0,
      upload4Web: 'sys/utils/upload4Web',
    }
  },
  computed: {
    ...mapGetters(['settings', 'member', 'mtoken', 'publickey']),
    sitetitle() {
      return process.env.APPTITLE;
    },
    rootPath() {
      return process.env.VUE_APP_API;
    },
    myHost() {
      let href = location.href;
      let pathname = location.pathname;
      if (pathname == '/') {
        return href;
      }
      return href.substring(0, pathname.length ? href.indexOf(pathname) : href.length) + '/';
    },
    myPath() {
      if (process.env.NODE_ENV === 'production') {
        return this.myHost + 'api/';
      }
      let devurl = this.baseUrl_dev;
      if (devurl && !devurl.endsWith('/')) {
        devurl += '/';
      }
      return devurl;
    },
    wsHost() {
      let host = this.myHost;
      // console.log('host', host, location.pathname)
      if (host.startsWith('https')) {
        return 'wss' + host.substring(5);
      } else {
        return 'ws' + host.substring(4);
      }
    },
    assetsPath() {
      return process.env.NODE_ENV === 'production' ? process.env.VUE_APP_ASSETPATH_PRD : process.env.VUE_APP_ASSETPATH_DEV;
    },
    uploadPic() {
      return 'site/uploadPic';
    },
    noimg() {
      return this.assetsPath + 'static/images/noimg.jpg';
    },
    isWeixin() {
      return isWeixin();
    },
    isMobile() {
      return isMobile();
    },
    sitetitle() {
      return this.apptitle || process.env.VUE_APP_TITLE || '管理系统';
    },
    siteUrls() {
      const base = `/`;
      return {
        home: `${base}`,
        service: `${base}service`,
        items: `${base}items`,
        news: `${base}infos`,
        newsview: `${base}infos/${this.id}`,
        zhuanjia: `${base}zhuanjia`,
        memberview: `${base}member/${this.id}`,
        user: `${base}user`,
        join: `${base}join`,
      }
    },
    headers() {
      return {mtoken: this.$store.getters.mtoken || ''};
    },
  },
  watch: {
  },
  mounted () {
    this.resize();
    if (process.client) {
      window.addEventListener('resize', () => {
        this.resize()
      }, false);
    }
  },
  methods: {
    resize() {
      this.ww = document.body.clientWidth;
      this.hh = document.body.clientHeight;
    },
    getImgW() {
      this.$nextTick(() => {
        this.w = this.$refs.body && this.$refs.body.offsetWidth;
      });
    },
    goBack(route) {
      if (!route) {
        this.$router.back();
      } else {
        this.$router.push(route);
      }
    },
    getParent(componentName) {
      if (!componentName) {
        return undefined
      }
      let parent = this.$parent || this.$root;
      let name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;
        if (parent) {
          name = parent.$options.componentName;
        }
      }

      return parent;
    },
    dispatch(componentName, eventName, params) {
      let parent = this.getParent(componentName);
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    timeout() {
      this.dispatch('index', 'timeout');
    },
    doLogout() {
      this.dispatch('index', 'logout');
    },
    doLogin(backUrl = '') {
      if (backUrl != null && !backUrl) {
        backUrl = this.$route.path;
      }
      this.dispatch('index', 'login', {backUrl: backUrl});
    },
    login(backRoute) {
      // 如果是微信浏览器，记住登录后返回路由
      this.doLogin(backRoute || this.$route);
    },
    // 检查登录
    checkLogin() {
      if (!this.member.id || !this.member.openid) {
        if (this.mtoken) {
          this.$store.dispatch(types.JY_LOGIN_MEMBER, {token: this.mtoken, callback: (flag) => {
            if (!flag) {
              this.login(this.$route);
            }
          }});
          return;
        }
        // console.log(this.member)
        setTimeout(() => {
          this.login(this.$route);
        }, 100);
      }
    },
    triggerWeb() {
      this.$store.commit(types.OTHER.reloadWeb);
    },
    goHome() {
      this.$router.push(this.siteUrls.home);
    },
    onClickLeft() {
      this.$router.push(this.backUrl || this.siteUrls.home);
    },
    doGet(options) {
      options.headers = Object.assign({}, this.headers);
      doGet(options);
    },
    doPost(options) {
      options.headers = Object.assign({}, this.headers);
      doPost(options);
    },
    doUpload4Vant(options) {
      if (!options.file) {
        console.error('未获取到上传参数：[file] ！');
        return;
      }
      /* eslint-disable no-undef */
      let param = new FormData();  // 创建form对象
      param.append('file', options.file);  // 通过append向form对象添加数据
      // 添加form表单中其他数据
      if (options.data) {
        Object.keys(options.data).forEach(key => {
          param.append(key, options.data[key]);
        });
      }
      // let config = Object.assign({}, this.header, {'Content-Type': 'multipart/form-data'});

      options.headers = Object.assign({}, this.headers);
      options.url = options.action || 'site/uploadPic';
      options.formData = param;
      options.contentType = 'multipart/form-data';
      options.timeout = 120000;

      doPost(this.$axios, this.$store, options);

      // 添加请求头
      // this.$axios.post(options.url, param, config)
      //   .then(res => {
      //     this.uploadCb4Axios(res, options);
      //   })
      //   .catch((res) => {
      //     this.uploadCb4Axios(res, options);
      //   })
    },
    doUpload4ElUpload(options) {
      const formData = new FormData();

      if (options.data) {
        Object.keys(options.data).forEach(key => {
          formData.append(key, options.data[key]);
        });
      }
      formData.append(options.filename, options.file, options.file.name);

      options.url = options.action || 'site/uploadPic';
      options.formData = formData;
      options.headers = Object.assign({}, this.headers);
      options.contentType = 'multipart/form-data';
      options.onUploadProgress = (e) => {
        if (e.total > 0) {
          e.percent = e.loaded / e.total * 100;
        }
        options.onProgress(e);
      };
      options.timeout = 120000;

      doPost(this.$axios, this.$store, options);
    },
    // 图片本地地址
    imgLocal(img) {
      if (!img) {
        return img;
      }
      return img.startsWith('//') || img.startsWith('http') ? img : `${this.assetsPath}static/images/${img}`;
    },
    // 图片地址
    imgPath(img) {
      if (!img) {
        return img;
      }
      return img.startsWith('//') || img.startsWith('http') ? img : `${this.rootPath}${img}`;
    },
    // 显示缩略图片
    photoSrc(pic, w = 200) {
      if (pic && (pic.startsWith('data\:') || pic.startsWith('http') || pic.startsWith('//'))) {
        return pic;
      }
      return this.rootPath +`site/thumb?url=${pic}&w=${w}`;// &_t=${Date.now()}
    },
    showSex(sex) {
      sex = sex ? sex.trim() : null;
      if (sex == '01') {
        return '男';
      } else if (sex == '02') {
        return '女';
      }
      return '未知';
    },
    // check status
    checkStatusType(status) {
      let type = '', types = ['danger', 'primary', 'success'];
      if (status === 9) {
        type = 'warning';
      } else {
        type = types[status];
      }
      return type;
    },
    rollStatusColor(status) {
      if (status == 'ZD') {
        return '#1989fa';
      } else if (status == 'BM') {
        return '#07c160';
      } else if (status == 'JF') {
        return '#ee0a24';
      } else if (status == 'DJ') {
        return '#7232dd';
      }
    },
    webPrice(price, showzero = true) {
      let value = null;
      if (showzero) {
        value = (price ? price / 100 : 0).toFixed(2);
      }
      value = (price ? (price / 100).toFixed(2) : null);
      if (value) {
        value = value.split('.');
        return `<span class="price-001">${value[0]}</span><small class="price-002">.${value[1]}</small>`
      }
      return value;
    },
    // 显示金额（int to float)
    showPrice(price, showzero = true) {
      return price ? price / 100 : (showzero ? 0 : null);
    },
    mobileOk(mobile) {
      return mobileOk(mobile);
    },
    // 格式化日期
    formatDate(date, fmt = 'yyyy-MM-dd') {
      if (!date) {
        return date;
      }
      // console.log(date)
      let _date = date;
      if (!(_date instanceof Date)) {
        if (typeof _date === 'string') {
          _date = _date.toDate();
        } else if (typeof _date === 'number') {
          _date = new Date(_date);
        }
      }
      if (!(_date instanceof Date)) {
        return date;
      }
      return formatDate(_date, fmt);
    },
  }
}